var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _ellipse, _path1, _path10, _g, _path11, _path12, _path13, _line, _line2, _circle, _circle2, _text, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse2, _ellipse3, _rect2, _path24, _path25, _path26, _polygon, _polygon2, _polygon3, _path27, _path28, _path29, _path30, _polyline, _circle3, _path31, _path32, _path33, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingstrategyplanningtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9292b7;}.cls-2{fill:#d8c4df;}.cls-3{fill:#f37c7d;}.cls-4{fill:#7467ae;}.cls-13,.cls-14,.cls-17,.cls-22,.cls-25,.cls-26,.cls-27,.cls-5,.cls-8{fill:none;stroke-miterlimit:10;}.cls-17,.cls-5{stroke:#000;}.cls-17,.cls-5,.cls-8{stroke-linecap:round;}.cls-5{stroke-width:1px;}.cls-15,.cls-6{fill:#2f2143;}.cls-7{fill:#5eb0a2;}.cls-8{stroke:#191847;stroke-width:0.5px;}.cls-9{clip-path:url(#clip-path);}.cls-10{fill:#32326b;}.cls-11{fill:#ffd664;}.cls-12{fill:#fff;}.cls-13,.cls-26,.cls-27{stroke:#fff;}.cls-13{stroke-width:0.31px;}.cls-14{stroke:#2f2143;stroke-width:1.06px;}.cls-15{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-16{fill:#9a499c;}.cls-17{stroke-width:0.82px;}.cls-18{fill:#f2efef;}.cls-19{fill:#54478d;}.cls-20{fill:#e5ac24;}.cls-21{fill:#cd922a;}.cls-22{stroke:#1f3242;stroke-width:1.35px;}.cls-23{fill:#1f3242;}.cls-24{fill:#386994;}.cls-25{stroke:#e5ac24;stroke-width:1.57px;}.cls-26{stroke-width:2.76px;}.cls-27{stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.61,138.5a24,24,0,1,1-24.05-24A24.05,24.05,0,0,1,222.61,138.5Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "branding strategy &amp;amp; planning tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.32,198.86l8.37-10.6a10.92,10.92,0,0,1,7.65-2.92c4.46.27,11.22.38,14.09-4.14,0,0,6-9.19,3.49-10.63,0,0-1.66-.82-4.44,2.05,0,0,.77-2.49-.82-3s-3.2,2.83-3.37,2.89c0,0-.73-2.85-2.22-1.62,0,0-1.79,1-2.38,5.8a2.37,2.37,0,0,0-3.2-.69s-4.44,1.95-15.17,2.77a12.65,12.65,0,0,0-6.32,3.82L173.56,189Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.28,177s1.84-10.62,3.21-11.16,20.2,3.07,20.7-9.51c0,0,.36-7.61,4-8.34,0,0,5.27-3,1.23-6.92,0,0-4.71-3.86-4.27-7.29,0,0,3.89-15.87-2-22.47,0,0-23.3-17.55-35.37-3s-16.66,10.95-6.19,50.25L101,169.24l5.32,5.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.62,277s-1.49-27.4,3.89-29.16c0,0,9.74-7.53,9.83-10,0,0,9.69,10.56,15.14,10.6,0,0,8.45,2,16.89-7.43,0,0,26.5-30.25,32.17-39.24,0,0,3-3.56-1.18-6.49l-12.23-8.79s-2.52-3.67-6.56,1.67c0,0-18.57,24.8-19,25.21s-4.73,5.39-11.51-4.71c0,0-15-20.51-19-22.17l3.21-11.07s.9-1.72-2.26-2.46-17.65-5.18-17.65-5.18-2.69-1.45-3.16,1.94S96,180.15,94.51,180.89,80.35,203.7,79.25,210a669.88,669.88,0,0,0-20,67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.34,237.84s-18.16-17.59-18.74-26.35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146,111.22s-.71,4.38-15.28,3.26c0,0-5.79.3-2.33,7.64,0,0,5.05,17.57-3.07,20.5,0,0-1.64.8-4.13-4.07,0,0-2.71-5-6.12-3.93,0,0-8.78,3.43-3.65,13.56,0,0-3.06,11.17-7.18,10.6,0,0-20-14.15-17.72-31.87s16-25.26,20.73-26.51,17.08-4.7,30.53,1.56C137.81,102,147.26,106.36,146,111.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.52,115.41s-6,1.76-5.11,17.46c0,0,1.57,16.8,6.44,30.27,0,0,5.91,19.31-15.84,18.58,0,0,2.11,16.72-13.18,20.46,0,0-17.68,2.93-17.65-9.81,0,0-15.41,4-12-16.87,0,0,.35-4.13,3.65-10S45.35,134,45.7,130.13s10.45-52.33,45.19-21.7v4.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89,117.24s-2.29-.38-2-3.6S90.14,107,91.81,107c0,0,2.19-.36,4.44,2.09C96.25,109.11,93.61,119.05,89,117.24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.45,148.18s3.4,5.86,6.81,3.92"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.38,154.6s-4.86,1.8-7.45-6.42"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.48,130.63a.39.39,0,0,1-.31-.15.41.41,0,0,1,.05-.58,19.85,19.85,0,0,0,1.82-2.12.41.41,0,1,1,.65.49,19.33,19.33,0,0,1-1.95,2.26.37.37,0,0,1-.26.1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 141.29,
    cy: 131.97,
    rx: 2.38,
    ry: 1.12,
    transform: "translate(-33.14 215.35) rotate(-68.6)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.09,126.68s2.7-5.32,6.29-2.46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.61,138.5a24,24,0,1,1-24.05-24A24.05,24.05,0,0,1,222.61,138.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "198.56 138.5 182.6 115.94 202.6 110.48 198.56 138.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "198.56 138.79 201.74 111.33 220.27 120.63 198.56 138.79"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M42,235.24A3.45,3.45,0,1,1,43.1,240,3.45,3.45,0,0,1,42,235.24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M39,217.57a3.45,3.45,0,1,1,1.08,4.75A3.46,3.46,0,0,1,39,217.57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M26.42,234.38a3.45,3.45,0,1,1-.68,4.82,3.45,3.45,0,0,1,.68-4.82"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 41.5,
    y1: 237.06,
    x2: 31.9,
    y2: 237.04
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.77,
    y1: 233.73,
    x2: 42.95,
    y2: 222.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 222.61,
    cy: 243.21,
    r: 8.43
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 527.85,
    cy: 251.64,
    r: 8.43
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(235.88 146.62)"
  }, "BRANDING STRATEGY ", /*#__PURE__*/React.createElement("tspan", {
    x: 76.65,
    y: 40
  }, "&amp; PLANNING"))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M654.58,145.88c-1.55-5.84-.75-12.72,12.31-18.79s38.26-3.43,43.07,16.61-.46,30.24,9.28,42.84S747,213.8,731.38,231.1c-26.81,18.9-70.22-2.86-74.11-13.4s2.29-27.38,11.22-41.47-12.26-21.3-13.91-30.35"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607,224l-1-3.4a3.14,3.14,0,0,1-3.35-.11,5.18,5.18,0,0,1-6-2s-2.09,1.49-5.35-.36c0,0-2.74-1.66-1.62-2.86,0,0,.83-.87,5.5,1.09,0,0-.91-4.36.57-4.63,0,0,1.58-.34,3.76,3.9,0,0-.19-3.78,1.23-3.48s3,3.77,3.47,4.92l1.32-.35s-1.56-4.56.3-4.77c0,0,1.8-.88,3.71,4.21l4.18-1s3.14-1.16,4.38,1.57l1.9,4.49S617.73,228.92,607,224Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M696.62,194.29l0-21.75s6.09,2.86,9.35-3.46c0,0,3.5-7.06-4.33-8.29,0,0-1.68-.35-4.16,1.37,0,0,2.87-17.72-5.84-23.16s-32.07-6.66-36.27,11.47c0,0,.56,2.3.87,4.63a113.88,113.88,0,0,1,.28,14.5c-.22,5.79,3.87,13.53,9.34,15.78a16.65,16.65,0,0,0,11.46,1s.81,10.28,1.17,12l18.13-1.16Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M706.27,199.15s-9.6-.4-8.5-2.79c0,0,.15-7.22-2.66-4.81s-13.17,2-17.34,1c0,0-1.39-1.56.18,6.08,0,0,.54.41-5.91,1.31C672,200,683.91,214,706.27,199.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M655.39,150.39c2.17-4.58,14.54-11.34,20.73-12.14,2.64,15.69,6.59,25,15.18,23,1.94,8.36,2.58,8.25,3.84,7.79s1.94-5,2.29-7.27c3.89-2.87,6-7.28,5.49-13.81s-5.95-20.5-24.16-17.18-26,9.85-23.37,19.59"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605.6,223.39s8.45,3,15-3.09c0,0,2.1,3.29,12.3,24,0,0,9.56-18.95,12-25.76,0,0,6.13-16.79,15-17.72,0,0,10.4-.29,12.57-.58,0,0,9.8,12,33.63-.76,0,0,12.73,1.22,18.64,9.41,0,0,4.89,6.42,13.3,28.21,0,0,9.43,24.2,11.19,30.27a21,21,0,0,1,0,9.58l-21.07-.23s4.14-3.13-9.4-30.58l-.45,30.58H666.42l-7.33-37S653.47,253,651,257.11c0,0-7.69,14.33-13.72,15.09,0,0-9.11,3.51-16.79-7.57C620.49,264.63,602.84,222.46,605.6,223.39Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M659.81,155.36s1.75-2.24,4.47,0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M671.43,155.86s3.78-2.71,6.32,1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M665.72,160.08l-1.52,5.61a1.5,1.5,0,0,0,1.89,1.83L668,167"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M668.5,175.78s6.91,4.27,10.44-3.31"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 674.59,
    cy: 161.24,
    rx: 0.88,
    ry: 1.64,
    transform: "translate(-14.48 240.34) rotate(-19.99)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 661.04,
    cy: 161.24,
    rx: 0.88,
    ry: 1.64,
    transform: "translate(-15.29 235.71) rotate(-19.99)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 592.31,
    y: 177,
    width: 28.88,
    height: 29.14,
    rx: 4.79
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M602.1,199.42a2.34,2.34,0,0,1-4.67,0v-10a2.34,2.34,0,0,1,4.67,0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M608.63,199.42a2.34,2.34,0,0,1-4.67,0V185.69a2.34,2.34,0,1,1,4.67,0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615.16,199.42a2.34,2.34,0,0,1-4.67,0V182.3a2.34,2.34,0,1,1,4.67,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "570.1 50.17 624.77 71.84 597.91 88.61 570.1 50.17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "570.1 50.17 611.15 80.48 611.15 91.31 616.47 78.41 570.1 50.17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "605.04 82.86 611.15 91.31 611.15 80.48 605.04 82.86"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151,29.67h-33a3.2,3.2,0,0,0-3.2,3.2V48.34a3.19,3.19,0,0,0,3.2,3.19h2.7c.2,1,.32,3.84-3.38,5.79,0,0,9.71-.47,9.85-5.79H151a3.19,3.19,0,0,0,3.2-3.19V32.87a3.2,3.2,0,0,0-3.2-3.2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.61,31.87A13.14,13.14,0,0,1,293,50.51a13.79,13.79,0,0,1-1.57,1.4,13.18,13.18,0,1,1,1.16-20Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M295.3,47.57l15.16,14.51a2.9,2.9,0,1,1-4,4.18L291.65,52.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M309.63,63.39a1.37,1.37,0,0,1,.05,2,1.38,1.38,0,1,1-2-1.91,1.38,1.38,0,0,1,1.95,0"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "393.68 81.86 409.31 92.79 416.24 75.02 431.87 85.95 438.8 68.17 454.44 79.1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 708.88,
    cy: 60.32,
    r: 15.93
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M351.45,246.19a2.76,2.76,0,1,1,.86,3.81,2.76,2.76,0,0,1-.86-3.81"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M349.06,232a2.76,2.76,0,1,1,.86,3.82,2.76,2.76,0,0,1-.86-3.82"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M338.94,245.5a2.76,2.76,0,1,1-.55,3.87,2.76,2.76,0,0,1,.55-3.87"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 351.02,
    y1: 247.65,
    x2: 343.33,
    y2: 247.64
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 354.45,
    y1: 244.98,
    x2: 352.19,
    y2: 235.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingstrategyplanningtab);
export default __webpack_public_path__ + "static/media/branding strategy & planning tab.fc0933cd9b00134c8f8c7c2e936850ca.svg";
export { ForwardRef as ReactComponent };